export default "__VITE_ASSET__BvW9Izq$__"